export const environment = {
  production: true,
  name: 'production',
  apiUrl: 'https://api.a-l-asso.fr',
};
